import $ from 'jquery';
import nav from './old-header/sk-header-nav';
import top from './old-header/sk-header-top';

const oldHeader = {
  init() {
    const navElement = $('#navigation');
    if (navElement.length < 1) {
      return;
    }
    const isSupport = navElement.hasClass('support');
    if (isSupport) {
      top.onScroll();
      nav.init();
    }
  }
};

const initHeader = {
  init() {
    oldHeader.init();
  }
};

export default initHeader;
